import {Injectable} from '@angular/core';
import {HttpService} from '../../../common/api/http.service';
import {
    APIResponse,
    FilterFieldOptionRequest,
    FilterFieldOptionResponse,
    SimpleMultiSeries,
} from '@core/interfaces/system/system-common';
import {Observable} from 'rxjs';
import {
    InvestmentOverviewRequest,
    OutcomeChartRequest,
    OutcomeChartResponse,
    OutcomeKpiResponse,
    OverlappingAssetRequest,
    OverlappingAssetResponse,
} from '@core/interfaces/engin/program-management/pm-reporting';
import {DownloadCSVUrl} from '@core/interfaces/engin/workflow-validation';

@Injectable()
export class PmReportingApi {
    private readonly prefix = 'pm/reporting';

    constructor(private api: HttpService) {}

    /*
     * APIs for Investment Overview
     */
    public getInvestmentOverview(param: InvestmentOverviewRequest): Observable<APIResponse<SimpleMultiSeries<string>>> {
        return this.api.post(`${this.prefix}/investment/overview`, param);
    }

    /*
     * APIs for Overlapping Assets
     */
    public getAssetOverlapBetweenProjects(
        request: OverlappingAssetRequest,
    ): Observable<APIResponse<OverlappingAssetResponse>> {
        return this.api.post(`${this.prefix}/overlapping-assets`, request);
    }

    public getAssetOverlapBetweenProjectsCsv(
        request: OverlappingAssetRequest,
    ): Observable<APIResponse<DownloadCSVUrl>> {
        return this.api.post(`${this.prefix}/overlapping-assets/csv`, request);
    }

    /*
     * APIs for Outcomes (legacy Optimizer)
     */
    public getChartDataSummarySpending(request: OutcomeChartRequest): Observable<APIResponse<OutcomeChartResponse>> {
        return this.api.post(`${this.prefix}/outcomes/charts/investment-plan/spending`, request);
    }

    public getChartDataSummaryOutcomes(request: OutcomeChartRequest): Observable<APIResponse<OutcomeKpiResponse>> {
        return this.api.post(`${this.prefix}/outcomes/charts/investment-plan/outcomes`, request);
    }

    public getChartDataProactiveForecast(request: OutcomeChartRequest): Observable<APIResponse<OutcomeChartResponse>> {
        return this.api.post(`${this.prefix}/outcomes/charts/investment-forecast/proactive`, request);
    }

    public getChartDataReactiveForecast(request: OutcomeChartRequest): Observable<APIResponse<OutcomeChartResponse>> {
        return this.api.post(`${this.prefix}/outcomes/charts/investment-forecast/reactive`, request);
    }

    public getChartDataFailureForecast(request: OutcomeChartRequest): Observable<APIResponse<OutcomeChartResponse>> {
        return this.api.post(`${this.prefix}/outcomes/charts/failure-forecast/failure`, request);
    }

    public getChartDataOutageForecast(request: OutcomeChartRequest): Observable<APIResponse<OutcomeChartResponse>> {
        return this.api.post(`${this.prefix}/outcomes/charts/failure-forecast/outage`, request);
    }

    public getChartDataRiskForecastByImpact(
        request: OutcomeChartRequest,
    ): Observable<APIResponse<OutcomeChartResponse>> {
        return this.api.post(`${this.prefix}/outcomes/charts/risk-forecast/impact`, request);
    }

    public getChartDataRiskForecastByCategory(
        request: OutcomeChartRequest,
    ): Observable<APIResponse<OutcomeChartResponse>> {
        return this.api.post(`${this.prefix}/outcomes/charts/risk-forecast/category`, request);
    }
    getFilterFieldOptions(body: FilterFieldOptionRequest): Observable<APIResponse<FilterFieldOptionResponse>> {
        return this.api.post(`${this.prefix}/options/filters/field`, body);
    }
}
